import React, { useCallback, useEffect, useState } from 'react'
import { subscribeToToasts, ToastPayload } from '../../utils/toast'
import { Toast, ToastItemData } from './Toast'

const EXIT_ANIMATION_MS = 280

type ToastProviderProps = {
  children?: React.ReactNode
}

export function ToastProvider({ children }: ToastProviderProps) {
  const [toasts, setToasts] = useState<ToastItemData[]>([])

  const dismiss = useCallback((id: string | number) => {
    let shouldScheduleRemoval = false
    setToasts(prev => {
      const target = prev.find(toast => toast.id === id)
      if (!target || target.exiting) {
        return prev
      }
      shouldScheduleRemoval = true
      return prev.map(toast =>
        toast.id === id ? { ...toast, exiting: true } : toast
      )
    })
    if (shouldScheduleRemoval) {
      setTimeout(() => {
        setToasts(prev => prev.filter(toast => toast.id !== id))
      }, EXIT_ANIMATION_MS)
    }
  }, [])

  const spawn = useCallback((payload: ToastPayload) => {
    setToasts(prev => {
      if (prev.some(toast => toast.id === payload.id && !toast.exiting)) {
        return prev
      }
      return [
        {
          id: payload.id,
          variant: payload.variant,
          message: payload.message,
          exiting: false,
        },
        ...prev,
      ]
    })
  }, [])

  useEffect(() => subscribeToToasts(spawn), [spawn])

  return (
    <>
      {children}
      <div className="aa-toast-region" aria-label="Notifications">
        {toasts.map(item => (
          <Toast key={item.id} item={item} onDismiss={dismiss} />
        ))}
      </div>
    </>
  )
}
